import PropTypes from 'prop-types';

// @mui
import { InputAdornment, TextField } from '@mui/material';
// components
import Iconify from '../../../components/iconify';

// ----------------------------------------------------------------------

BlogPostsSearch.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
};

export default function BlogPostsSearch({ value = '', onChange, placeholder = 'Search posts...' }) {
  const controlProps = onChange
    ? { value, onChange: (event) => onChange(event.target.value) }
    : { defaultValue: value };

  return (
    <TextField
      fullWidth
      size="small"
      placeholder={placeholder}
      {...controlProps}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Iconify icon="eva:search-fill" sx={{ width: 20, height: 20, color: 'text.disabled' }} />
          </InputAdornment>
        ),
      }}
    />
  );
}

